import { Component, ViewChild, TemplateRef, AfterViewInit, ChangeDetectorRef, ElementRef, OnDestroy } from '@angular/core';
import { MatRowDef, MatTableModule } from '@angular/material/table';
import { MatDialogModule, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatSelectModule } from '@angular/material/select';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
import { CompanyAttributes } from '@albatrosdeveloper/ave-models-package';
import { MatSnackBar } from '@angular/material/snack-bar';
import ReasonRejectionAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/masters/reason-rejection/reason-rejection.entity';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { NgSelectModule } from '@ng-select/ng-select';
import { ICreateReasonRejection } from './interfaces/create-reason-rejection.interface';
import { IUpdateReasonRejection } from './interfaces/update-reason-rejection.interface';
import { ReasonRejectionService } from './reason-rejection.service';
import { CustomMatPaginatorIntl } from 'app/mock-api/common/customPaginatorIntl';
import { getCode } from 'app/utils/method';
import { RejectionTypeService } from '../rejection-type/rejection-type.service';
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { Subscription } from 'rxjs';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { GeneralFiltersComponent } from "../../filters/general-filters/general-filters.component";
import { ConfigurationFiltersComponent } from '../../filters/configuration-filters/configuration-filters.component';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";



@Component({
  selector: 'app-reason-for-rejection',
  templateUrl: './reason-for-rejection.component.html',
  styleUrls: ['./reason-for-rejection.component.scss'],
  standalone: true, 
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenavContainer,
    NgSelectModule,
    MatTabsModule,
    NgxMatSelectSearchModule,
    FilterComponent,
    StatusFiltersComponent,
    GeneralFiltersComponent,
    HoverMenuDirective
],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],
})
export class ReasonForRejectionComponent implements AfterViewInit, OnDestroy{
  getCode = getCode;
  displayedColumns: string[] = ["name","withoutPrice","freeStock","acceptComment","isWaste","status", "actions"];
  currentCreateReasonRejection: ICreateReasonRejection = this.initializeCreateReasonRejection();
  currentUpdateReasonRejection: IUpdateReasonRejection | undefined;

  dataSource: ReasonRejectionAttributes[] = [];
  companyList: CompanyAttributes[] = [];

  // paymentTypeList: { key: ReasonRejectionTypeEnum, value: string }[] = [];

  searchQuery: string = '';
  totalItems: number = 0;
  pageSize: number = 50;
  pageIndex: number = 0;

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit:MatDialogRef<any>;

  listActivities: { code: string; name: string }[]= [
    {code: '1', name:'PEDIDO'},
    {code: '2', name:'COTIZACIÓN'},
    {code: '3', name:'VENTA DIRECTA'},
    {code: '4', name:'NUEVO CLIENTE'},
    {code: '5', name:'CAMBIO DE PRODUCTO'},
    {code: '6', name:'COBRANZA'}
  ]

  reasonRejectionTypeList: ReasonRejectionAttributes[] = [];
  filteredReasonRejectionTypeList: ReasonRejectionAttributes[] = [];
  searchReasonRejectionType: string = '';
  selectedStatuses: number[] = [0,1];
  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchInput") searchInput!: ElementRef;

  //BUSCADOR
  searchSubscription: Subscription;

  form: FormGroup;
  
  constructor(
    private readonly reasonService: ReasonRejectionService,
    private readonly rejectionTypeService: RejectionTypeService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      rejectionTypeId:[]
    });
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.setupPaginationAndSorting();
    this.findAllWithCount();
    this.fetchReasonRejectionTypes();
    // this.fetchAllCompanies();
    // this.paymentTypeList = Object.entries(ReasonRejectionTypeEnum).map(([key, value]) => ({
    //   key: key as ReasonRejectionTypeEnum,  // Aseguramos el tipo correcto
    //   value
    // }));
  }


private initializeCreateReasonRejection(): ICreateReasonRejection {
  return {
    name: "",
    typeIds: [],
    externalKeys: { code: "" },
    description: "",
    indicatorColor: ""
  };
}


  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }

  findAllWithCount(): void {
    const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" = this.sort.direction === "asc" ? "ASC" : "DESC";
    const selectedTypeCodes = this.form.get('rejectionTypeId')?.value || [];

    this.reasonService
      .findAllWithCount(
        { currentPage: pageIndex, limitPerPage: this.pageSize, search: this.searchQuery, sort: sortField, sortDirection: sortDirection }, selectedTypeCodes,
        this.selectedStatuses
      )
      .subscribe((data) => {
        this.dataSource = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.paginator.length = this.totalItems;
        this.cdr.detectChanges()
      });
  }

  private getSortField(): keyof ReasonRejectionAttributes {
    const validSortFields: (keyof ReasonRejectionAttributes)[] = ["name", "statusId"];
    return validSortFields.includes(this.sort.active as keyof ReasonRejectionAttributes) ? (this.sort.active as keyof ReasonRejectionAttributes) : "name";
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.findAllWithCount();
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }

  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          this.paginator.pageIndex = 0;
          this.findAllWithCount();
        }
      });
  }

  trackByFn(index: number, item: ReasonRejectionAttributes): string {
    return item._id.toString();
  }

  openCreateModal(): void {
    this.currentCreateReasonRejection = this.initializeCreateReasonRejection();
    this.fetchReasonRejectionTypes();
    this.dialogRefAdd = this.dialog.open(this.addModal, { panelClass: "form-modal", disableClose: true })
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createReasonRejection());
    this.dialogRefAdd.afterClosed().subscribe((result) => { result });
  }

  openEditModal(condition: ReasonRejectionAttributes): void {
    this.fetchReasonRejectionTypes();
    this.currentUpdateReasonRejection = { 
      ...condition,
      externalKeys: {
        code: condition.externalKeys?.code
          ?? (condition as any).code
          ?? (condition as any).excode
          ?? ""
      },
      typeIds: (condition.type && Array.isArray(condition.type) && condition.type.length > 0 ? condition.type.map(e => String(e._id)) : []) ?? []
    };
    this.dialogRefEdit = this.dialog.open(this.editModal, { panelClass: "form-modal", disableClose: true })
    // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updateReasonRejection(condition._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => { result });
  }

  createReasonRejection(): void {
    this.reasonService.create(this.currentCreateReasonRejection).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
        this.findAllWithCount();
        this.dialogRefAdd.close();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  updateReasonRejection(id: string): void {
    if (this.currentUpdateReasonRejection) {
      const updatedReasonRejection: IUpdateReasonRejection = { 
        ...this.currentUpdateReasonRejection,
        typeIds: (this.currentUpdateReasonRejection as any).typeIds,
       };
      this.reasonService.update(id, updatedReasonRejection).subscribe({
        next: () => {
          this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
          this.findAllWithCount();
          this.dialogRefEdit.close();
        },
        error: (err) => {
          this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
        }
      });
    }
  }

  onStatusChange(event: boolean, condition: ReasonRejectionAttributes): void {
    const originalStatusId = condition.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedReasonRejection:any = { statusId: updatedStatusId };

    this.reasonService.update(condition._id.toString(), updatedReasonRejection).subscribe({
      next: () => {
        this.findAllWithCount();
      },
      error: () => {
        condition.statusId = originalStatusId; // Volver al estado original si falla
        this.snackBar.open('Error al actualizar el estado.', 'Cerrar', { duration: 3000 });
        this.findAllWithCount();
      }
    });
  }

  openDeleteDialog(condition: ReasonRejectionAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: condition, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.delete(condition._id.toString()));
  }

  delete(id: string): void {
    this.reasonService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.snackBar.open('Registro eliminado con éxito', 'Cerrar', { duration: 3000 });
    });
  }

  //filter
  fetchReasonRejectionTypes() {
    this.rejectionTypeService.findToComboBox().subscribe({
      next: (res) => {
        this.reasonRejectionTypeList = res.data;
        this.filteredReasonRejectionTypeList = this.reasonRejectionTypeList;
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener los motivos de cancelación.","Cerrar",{ duration: 3000 }
        );
      },
    });
  }

  changueOptionRejection(event) {
    if (!this.reasonRejectionTypeList) {
      return;
    }
    let search = event;
    if (!search) {
      this.filteredReasonRejectionTypeList = this.reasonRejectionTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredReasonRejectionTypeList = this.reasonRejectionTypeList.filter(item => item.name.toLowerCase().indexOf(search) > -1)
  }

  getRejectionTypeNameById(id: string): string {
    const rejection = this.reasonRejectionTypeList.find(c => c.id === Number(id));
    return rejection ? rejection.name : 'Desconocido';
  }

  onFreeStockChange(event: boolean, reason: any): void {
    const originalStatusId = reason.freeStock;
    const updatedStatusId = event ? true : false;
    const updatedRejectionType = { ...reason, freeStock: updatedStatusId };

    this.reasonService
      .update(reason._id.toString(), updatedRejectionType)
      .subscribe({
        next: () => {
          this.findAllWithCount();
        },
        error: () => {
          reason.freeStock = originalStatusId; // Volver al estado original si falla
          this.snackBar.open("Error al actualizar.", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
        },
      });
  }

  
  onAcceptChange(event: boolean, reason: any): void {
    const originalStatusId = reason.acceptComment;
    const updatedStatusId = event ? true : false;
    const updatedRejectionType = { ...reason, acceptComment: updatedStatusId };

    this.reasonService
      .update(reason._id.toString(), updatedRejectionType)
      .subscribe({
        next: () => {
          this.findAllWithCount();
        },
        error: () => {
          reason.acceptComment = originalStatusId; // Volver al estado original si falla
          this.snackBar.open("Error al actualizar.", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
        },
      });
  }

    
  onWasteChange(event: boolean, reason: any): void {
    const originalStatusId = reason.isWaste;
    const updatedStatusId = event ? true : false;
    const updatedRejectionType = { ...reason, isWaste: updatedStatusId };

    this.reasonService
      .update(reason._id.toString(), updatedRejectionType)
      .subscribe({
        next: () => {
          this.findAllWithCount();
        },
        error: () => {
          reason.isWaste = originalStatusId; // Volver al estado original si falla
          this.snackBar.open("Error al actualizar.", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
        },
      });
  }

  onWithoutPriceChange(event: boolean, reason: any): void {
    const originalStatusId = reason.withoutPrice;
    const updatedStatusId = event ? true : false;
    const updatedRejectionType = { ...reason, withoutPrice: updatedStatusId };

    this.reasonService
      .update(reason._id.toString(), updatedRejectionType)
      .subscribe({
        next: () => {
        this.findAllWithCount();
      },
      error: (err) => {
        reason.withoutPrice = originalStatusId || false; // Volver al estado original si falla
        this.snackBar.open(err.error.message || 'Error al actualizar el registro', "Cerrar", {
          duration: 3000,
        });
        this.findAllWithCount();
      },
    });
  }

  onFilter(){
    this.findAllWithCount();
  }

  clearFilters(): void {
    this.form.reset();
    this.selectedStatuses = [];
    this.searchQuery = "";
    this.findAllWithCount();
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }

  applyStatusFilter(){
    this.paginator.pageIndex = 0;
    this.findAllWithCount();
  }

}
